import React, { useState, useRef,useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { DatePicker, TimePicker } from "antd";
import { Nullable } from "primereact/ts-helpers";
import { useHeaderFilters } from '../../context/HeaderFilterContext';
import CommonSelect from "../../core/common/commonSelect";
import type { Option } from "../../core/common/commonSelect";
import api from "../../api";
import { DatesSetArg } from '@fullcalendar/core';
import { useParams, useNavigate } from "react-router-dom";
import { encryptQuery,decryptQuery } from "../../utils/encryption";
import Footer from "../../Footer";
import {  useSelector } from "react-redux";
import { useFilterData } from "../../context/FilterContext";
import { useIsMobile } from "../../hooks/useIsMobile";
import { toast, ToastContainer } from "react-toastify";


 
const AttendanceCalendar = () => {
  const isMobile = useIsMobile(991);
  const { setFilters } = useHeaderFilters();
  const navigate = useNavigate();
  const { encryptedQuery } = useParams<{ moduleName: string; encryptedQuery?: string }>();
  const { filtersData } = useFilterData();
  console.log("filtersData in dropdown component:", filtersData);

  const dataLayout    = useSelector((state: any) => state.themeSetting.dataLayout)
    const expandedWidth  = 40
    const collapsedWidth =  72
    const sidebarWidth = dataLayout === 'mini_layout'
                         ? collapsedWidth
                         : expandedWidth


  const [users, setUsers] = useState<any[]>([]);
  const [isReportingHead, setIsReportingHead] = useState(false);
  const [userRole, setUserRole] = useState<number | null>(null);
  const [loggedInUserId, setLoggedInUserId] = useState<string | null>(null);
  const [defaultUser, setDefaultUser] = useState<any>(null);
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);
  const [currentView, setCurrentView] = useState<{ start: string; end: string; type: string } | null>(null);
  const [attendanceRecords, setAttendanceRecords] = useState<any[]>([]);
  const [TodayHours, setTodayHours] = useState("0");
  const [TotalUnverifiedrecord, setTotalUnverifiedrecord] = useState<number | null>(0);
  const [TotalMinute, setTotalMinute] = useState("0");
  const [TotalBreakminute, setTotalBreakminute] = useState("0");
  const [errorCount, setErrorCount] = useState<number | null>(0);
  const [events, setEvents] = useState<any[]>([]);
  const [colorMapping, setColorMapping] = useState<Record<string, string>>({});
  const [datewiseHours, setDatewiseHours] = useState<Record<string, string>>({});
  const [weekSummaryMap, setWeekSummaryMap] = useState<Record<string, AttendanceItem['in_out_summary']>>({});
  const [daySummary, setDaySummary] = useState<AttendanceItem['in_out_summary']>([]);

/* Single effect to handle URL → state whenever encryptedQuery changes*/
useEffect(() => {
  if (encryptedQuery && users.length) {
    try {
      const decoded = decodeURIComponent(encryptedQuery);
      const data = decryptQuery(decoded);
      const userExists = users.some(
        (emp) => emp.value === data?.selectedUserId
      );
      if (userExists) {
        setSelectedUserId(data?.selectedUserId);
        return;
      }
    } catch (e) {
      console.warn("Failed to decrypt attendance query:", e);
    }
  }
  if (!encryptedQuery) {
    const saved = localStorage.getItem("attendanceCalendarFilters");
    if (saved) {
      navigate(`/attendance-view/C/${encodeURIComponent(saved)}`, { replace: true });
    }
  }
  // fallback to default
  setSelectedUserId(loggedInUserId);
}, [encryptedQuery, loggedInUserId,users]);

/****update URL** and **update local state**/
const handleUserChange = (userId: string) => {
  if (userId === loggedInUserId) {
    // reset to base
    localStorage.removeItem("attendanceCalendarFilters");
    navigate(`/attendance-view/C`, { replace: false });
    setSelectedUserId(loggedInUserId);
  } else {
    const cipher = encryptQuery({ selectedUserId: userId });
    localStorage.setItem("attendanceCalendarFilters", cipher);
    const safe = encodeURIComponent(cipher);
    navigate(`/attendance-view/C/${safe}`, { replace: false });
    setSelectedUserId(userId);
  }
};


  type GetColorParams = {
    total_paid: number;
    total_paid_override: number;
    paid_working: number;
    paid_holidayweekoff: number;
    paidleave: number;
  };
  
  const getColor = ({
    total_paid,
    total_paid_override,
    paid_working,
    paid_holidayweekoff,
    paidleave,
  }: GetColorParams): string => {
    // Case: full week off/holiday
    if (paid_holidayweekoff === 1) return "#F4EFFF"; // Light purple
  
    // Case: full paid leave
    if (paidleave === 1) return "#D6EEFF"; // Light blue
  
    // Case: half paid leave + no work => half blue, half red
    if (paidleave === 0.5 && paid_working === 0) {
      return "linear-gradient(to right, #D6EEFF 50%, #FFF0F0 50%)";
    }
  
    // Case: half paid leave + half work => blue + green
    if (paidleave === 0.5 && paid_working === 0.5) {
      return "linear-gradient(to right, #D6EEFF 50%, #E6FFE6 50%)";
    }
  
    // Case: half working + no leave => red + green
    if (paid_working === 0.5 && paidleave === 0) {
      return "linear-gradient(to right, #FFF0F0 50%, #E6FFE6 50%)";
    }
  
    // Case: full work
    if (paid_working === 1) return "#E6FFE6"; // Light green
  
    // Case: no work, no leave
    if (paid_working === 0 && paidleave === 0 && paid_holidayweekoff === 0) {
      return "#FFF0F0"; // Light red
    }
  
    // Fallback for override-based display if none of the above applied
    if (total_paid !== total_paid_override) {
      if (total_paid_override === 0) return "#FFF0F0";
      if (total_paid_override === 0.5)
        return "linear-gradient(to right, #FFF0F0 50%, #E6FFE6 50%)";
      if (total_paid_override === 1) return "#E6FFE6";
    }
  
    return "#F0F0F0"; // Default grey
  };
  

  // Define the AttendanceItem interface
interface AttendanceItem {
    id: number;
    user_id: number;
    date: string;
    paid_leave: number;
    paid_holiday_weekoff: number;
    paid_working: number;
    total_paid: number;
    total_paid_override: number;
    is_verified: number;
    remark: string;
    created_at: string;
    updated_at: string;
    work_mins: number;
    break_mins: number;
    leave_mins: number;
    total_mins: number;
    in_time: string | null;
    out_time: string | null;
    verified_by: number | null;
    verified_date: string | null;
    user_name: string;
    emp_photo: string | null;
    designation: string;
    verified_by_name: string | null;
    image_url: string;
    in_out_summary: {
      in_time?: string;
  out_time?: string;
      total_minutes?: number;
    }[];
  }
  
  // Define the shape of the API response
  type AttendanceApiResponse = {
    data?: {
      data?: AttendanceItem[];
    };
    today_hours?: string;
    unverifiedrecord?: number;
    total_mins?: string;
    break_mins?: string;
    attendance_error_count?: number;
  };
  
/*fetches attendance data for an employee based on currentview*/
const fetchAttendance = async () => {
    let fromDate: string, toDate: string;
  
    if (selectedDate) {
      fromDate = toDate = selectedDate;
    } else if (currentView) {
      const fromDateObj = new Date(currentView.start);
      fromDate = fromDateObj.toISOString().split("T")[0];
  
      const toDateObj = new Date(currentView.end);
      toDateObj.setDate(toDateObj.getDate() - 1);
      toDate = toDateObj.toISOString().split("T")[0];
    } else {
      return;
    }
  
    let employeeId = null;
  
    if (userRole === 1 || (userRole === 2 && isReportingHead)) {
      employeeId = selectedUserId || loggedInUserId;
    } else if (userRole === 2 && !isReportingHead) {
      employeeId = loggedInUserId;
    }
  
    if (!employeeId) return;
  
    const payload = {
      employeeId,
      fromDate,
      toDate,
    };
  
    try {
      const response: AttendanceApiResponse = await api("/show-attendance-for-calender", {
        method: "POST",
        body: payload,
      });
  
      const records = response.data?.data || [];
      setAttendanceRecords(records);
  
      setTodayHours(response.today_hours || "00:00");
      setTotalUnverifiedrecord(response.unverifiedrecord ?? 0);
      setTotalMinute(response.total_mins || "00:00");
      setTotalBreakminute(response.break_mins || "00:00");
      setErrorCount(response.attendance_error_count ?? 0);
  
      let selectedSummary: AttendanceItem['in_out_summary'] = [];
      let selectedWeekSummaryLoop: Record<string, AttendanceItem['in_out_summary']> = {};

      setWeekSummaryMap(selectedWeekSummaryLoop);
  
      const map: Record<string, string> = {};
  
      const clearVacationIcons = () => {
        const vacationIcons = document.querySelectorAll(".vacation-icon");
        vacationIcons.forEach((icon) => icon.remove());
      };
  
      const addVacationIcon = (date: string, paidLeave: number) => {
        const cell = document.querySelector(`[data-date="${date}"]`) as HTMLElement;
        if (cell) {
          const existingIcon = cell.querySelector(".vacation-icon");
          if (!existingIcon && (paidLeave === 0.5 || paidLeave === 1)) {
            const vacationIcon = document.createElement("i");
            vacationIcon.className = "fa fa-umbrella-beach vacation-icon";
            vacationIcon.style.cssText = `
              position: absolute;
              top: 5px;
              left: 5px;
              font-size: 14px;
              color: #0074B7;
            `;
            cell.style.position = "relative";
            cell.appendChild(vacationIcon);
          }
        }
      };
  
      clearVacationIcons();
  
      records.forEach((record) => {
        // each record is processed ONCE
        if (!map[record.date]) {
          const color = getColor({
            total_paid_override: record.total_paid_override,
            paid_holidayweekoff: record.paid_holiday_weekoff,
            paidleave: record.paid_leave,
            paid_working: record.paid_working,
            total_paid: record.total_paid,
          });
  
        map[record.date] = color;

        addVacationIcon(record.date, record.paid_leave);
  
        if (fromDate && record.date === fromDate) {
          selectedSummary = record.in_out_summary;
        }
  
        selectedWeekSummaryLoop[record.date] = record.in_out_summary;
      }
    });
  
      const datewiseHours: Record<string, string> = {};
  
      records.forEach((record) => {
        let totalMinutes = 0;
        if (record.in_out_summary.length > 0) {
          totalMinutes = record.in_out_summary.reduce(
            (sum, entry) => sum + (entry.total_minutes || 0),
            0
          );
        }
  
        const formattedTime = totalMinutes
          ? `${String(Math.floor(totalMinutes / 60)).padStart(2, "0")}:${String(totalMinutes % 60).padStart(2, "0")}`
          : "00:00";
  
        datewiseHours[record.date] = formattedTime;
      });
  
      setColorMapping(map);
      setDatewiseHours(datewiseHours);
      setDaySummary(selectedSummary);
  
      applyCellColors(map, datewiseHours);
      applySummary(selectedWeekSummaryLoop,selectedSummary);

    } catch (err) {
      if (err instanceof Error) {
        console.error("Failed to fetch attendance:", err.message);
      } else {
        console.error("Unknown error while fetching attendance");
      }
    }
  };
  
  /*chooses which summary to show*/
  const applySummary = (
    weekSummaryMap: Record<string, AttendanceItem['in_out_summary']>,
    selectedSummary?: AttendanceItem['in_out_summary'] // for dayGridDay
  ) => {
    if (!currentView) return;
  
    const calendarBody = document.querySelector(".fc-scrollgrid-sync-table tbody");
    if (!calendarBody) return;
  
    const observer = new MutationObserver(() => {
      if (currentView.type === "dayGridWeek") {
        renderWeekSummary(weekSummaryMap);
      } else if (currentView.type === "dayGridDay" && selectedSummary) {
        renderDaySummary(selectedSummary);
      }
      observer.disconnect();
    });
  
    observer.observe(calendarBody, { childList: true, subtree: true });
  
    if (calendarBody.children.length > 0) {
      if (currentView.type === "dayGridWeek") {
        renderWeekSummary(weekSummaryMap);
      } else if (currentView.type === "dayGridDay" && selectedSummary) {
        renderDaySummary(selectedSummary);
      }
      observer.disconnect();
    }
  };
  
/*renders week summary*/
function renderWeekSummary(weekSummaryMap: Record<string, AttendanceItem['in_out_summary']>) {
  for (const date in weekSummaryMap) {
      const summary = weekSummaryMap[date];
      const cell = document.querySelector(`.fc-scrollgrid-sync-table td[data-date="${date}"]`);

      if (cell) {
          const dayFrameDiv = cell.querySelector('.fc-daygrid-day-frame.fc-scrollgrid-sync-inner');

          if (dayFrameDiv) {
              const previousSummaries = dayFrameDiv.querySelectorAll('[data-summary]');
              previousSummaries.forEach(el => el.remove());

              // Create the new summary div
              const summaryDiv = document.createElement('div');
              summaryDiv.setAttribute('data-summary', 'true');

              summaryDiv.style.fontSize = '9px';
              summaryDiv.style.marginTop = '5px';

              if (summary && summary.length > 0) {
                  const formatTime = (timeString: string | undefined) => {
                      if (!timeString) return "-";
                      const parts = timeString.split(" ")[1]?.split(":");
                      return parts ? `${parts[0]}:${parts[1]}` : "-";
                  };

                  let tableRows = "";
                  let totalMinutes = 0;

                  summary.forEach(entry => {
                      totalMinutes += entry.total_minutes || 0;

                      let inTime = formatTime(entry.in_time);
                      let outTime = formatTime(entry.out_time);
                      if (!outTime || outTime === "-") outTime = "NOW";

                      const inOutTime = `${inTime}-${outTime}`;
                      const mins = entry.total_minutes ?? 0;
                      const hrs = String(Math.floor(mins / 60)).padStart(2, '0');
                      const minsRem = String(mins % 60).padStart(2, '0');
                      const formattedHrs = `${hrs}:${minsRem}`;

                      tableRows += `
                          <tr style="height: 16px;">
                              <td style="border: 1px solid #000; padding: 2px; font-size: 10px; width: 70%;">${inOutTime}</td>
                              <td style="border: 1px solid #000; padding: 2px; font-size: 10px; width: 30%;">${formattedHrs}</td>
                          </tr>
                      `;
                  });

                  const totalHrs = String(Math.floor(totalMinutes / 60)).padStart(2, '0');
                  const totalMins = String(totalMinutes % 60).padStart(2, '0');
                  const formattedTotal = `${totalHrs}:${totalMins}`;

                  summaryDiv.innerHTML = `
                      <table style="width: 100%; color:black; border-collapse: collapse; text-align: center; font-size: 10px; border: 1px solid #000; margin-top: -33px">
                          <thead>
                              <tr style="background: #f0f0f0;">
                                  <th style="border: 1px solid #000; width: 70%; line-height:20px; height:20px">IN-OUT</th>
                                  <th style="border: 1px solid #000; width: 30%; line-height:20px; height:20px">HRS</th>
                              </tr>
                          </thead>
                          <tbody>${tableRows}</tbody>
                          <tfoot>
                              <tr style="background: #d3d3d3; font-weight: bold; height: 18px; font-size: 10px;">
                                  <td colspan="2" style="border: 1px solid #000; padding: 2px; text-align: center; font-weight: bold;">
                                      ${formattedTotal}
                                  </td>
                              </tr>
                          </tfoot>
                      </table>
                  `;
              } else {
                  summaryDiv.innerHTML = `
                      <p style="text-align: center; margin-top: 8px; font-style: italic; font-size: 12px;">No records.</p>
                  `;
              }

              dayFrameDiv.appendChild(summaryDiv);
          }
      }
  }
}

/*renders day summary*/
function renderDaySummary(selectedDaySummary: AttendanceItem['in_out_summary']) {
  const cell = document.querySelector(`.fc-scrollgrid-sync-table td[data-date]`);
  if (!cell) return;

  const dayFrameDiv = cell.querySelector('.fc-daygrid-day-frame.fc-scrollgrid-sync-inner');
  if (!dayFrameDiv) return;

  // Clear any previous summary
  const previousSummaries = dayFrameDiv.querySelectorAll('[data-summary]');
  previousSummaries.forEach(el => el.remove());

  const summaryDiv = document.createElement('div');
  summaryDiv.setAttribute('data-summary', 'true');
 
  if (selectedDaySummary && selectedDaySummary.length <= 0) {
    summaryDiv.style.fontSize = '12px';  // Larger font if no records
    summaryDiv.style.marginTop = '-29px';  
  } else{
    summaryDiv.style.fontSize = '10px';
    summaryDiv.style.marginTop = '-29px';  
  }

  if (selectedDaySummary && selectedDaySummary.length > 0) {
    // Calculate total work hours
    const totalMinutes = selectedDaySummary.reduce((sum, entry) => sum + (entry.total_minutes || 0), 0);
    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;
    const formattedTotalHours = `${String(totalHours).padStart(2, '0')}:${String(remainingMinutes).padStart(2, '0')}`;

    // Build table rows
    const tableRows = selectedDaySummary.map(entry => {
      const inTimeFormatted = entry.in_time ? entry.in_time.split(" ")[1] : "-";
      const outTimeFormatted = entry.out_time ? entry.out_time.split(" ")[1] : "-";
      const formattedMinutes = entry.total_minutes != null
        ? `${String(Math.floor(entry.total_minutes / 60)).padStart(2, '0')}:${String(entry.total_minutes % 60).padStart(2, '0')}`
        : "00:00";

      return `
        <tr>
          <td style="border: 1px solid #000; padding: 8px;">${formatTime(inTimeFormatted)}</td>
          <td style="border: 1px solid #000; padding: 8px;">${formatTime(outTimeFormatted)}</td>
          <td style="border: 1px solid #000; padding: 8px;">${formattedMinutes}</td>
        </tr>
      `;
    }).join('');

    // Final table HTML
    summaryDiv.innerHTML = `
      <table style="width: 100%; color:black; border-collapse: collapse; text-align: center; font-size: 15px; border: 1px solid #000;">
        <thead>
          <tr style="background: #f0f0f0; border: 1px solid #000;">
            <th style="border: 1px solid #000; padding: 8px; line-height:25px; height:25px;">IN TIME</th>
            <th style="border: 1px solid #000; padding: 8px; line-height:25px; height:25px;">OUT TIME</th>
            <th style="border: 1px solid #000; padding: 8px; line-height:25px; height:25px;">TOTAL</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows}
        </tbody>
        <tfoot>
          <tr style="background: #d3d3d3; font-weight: bold;">
            <td colspan="2" style="border: 1px solid #000; padding: 8px;">TOTAL</td>
            <td style="border: 1px solid #000; padding: 8px;">${formattedTotalHours}</td>
          </tr>
        </tfoot>
      </table>
    `;
  } else {
    summaryDiv.innerHTML = `<p style="text-align: center; margin-top: 12px; font-style: italic;">No records.</p>`;
  }
  dayFrameDiv.appendChild(summaryDiv);
}

const formatTime = (timeString: string | undefined): string => {
  if (!timeString || timeString === "-") return "-"; // Handle null, empty, or "-" values

  const [hours, minutes] = timeString.split(":").map(Number); // Extract only hours and minutes
  if (isNaN(hours) || isNaN(minutes)) return "-"; // Handle invalid time

  const period = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;

  return `${formattedHours}:${String(minutes).padStart(2, "0")} ${period}`;
};

function clearPreviousSummaries() {
  document.querySelectorAll('[data-summary]').forEach(el => el.remove());
}

const handleDatesSet = (arg: DatesSetArg) => {
  clearPreviousSummaries();

 document.querySelectorAll("button.fc-dayGridMonth-button").forEach(button => {
  button.classList.remove("fc-dayGridMonth-button");
  button.classList.add("fc-button");
  button.classList.add("fc-button-primary");
  });

  // Only apply summaries if current view is week
  if (arg.view.type === "dayGridWeek") {
    renderWeekSummary(weekSummaryMap); // Show all summaries for the week
  } else if (arg.view.type === "dayGridDay") {
    renderDaySummary(daySummary); // Show only selected day’s summary
  }

  getCurrentRange();
};
  
    /* apply cell colors and ellipse*/
    const applyCellColors = (
      colorMapping: Record<string, string>,
      datewiseHours: Record<string, string>
    ) => {
      setTimeout(() => {
        const calendarCells = document.querySelectorAll<HTMLElement>(".fc-day");
        const today = new Date();
        const todayDate = today.toISOString().split("T")[0];
    
        calendarCells.forEach((cell) => {
          const date = cell.getAttribute("data-date");
    
          // Cleanup previous styles and elements
          cell.style.backgroundColor = ""; // Reset background color
          cell.style.backgroundImage = ""; // Reset background image
          cell.style.backgroundSize = "";
          cell.style.backgroundRepeat = "";
          
          const existingEllipse = cell.querySelector(".hours-ellipse");
          if (existingEllipse) existingEllipse.remove();
    
          // Apply new colors if applicable
          if (date && colorMapping[date]) {
            const color = colorMapping[date];
    
            if (color.includes("linear-gradient")) {
              cell.style.backgroundImage = color;
              cell.style.backgroundColor = "transparent";
              cell.style.backgroundSize = "100% 100%";
              cell.style.backgroundRepeat = "no-repeat";
              cell.style.backgroundPosition = "center center";
            }           
            else {
              cell.style.backgroundColor = color;
            }
    
            if (date === todayDate) {
              cell.style.setProperty("background-color", "#fcf8e3", "important");
            }
          } else {
            if (date !== todayDate) {
              cell.style.backgroundColor = "#EAEAEA"; // Light Grey
            }
          }

          if (!currentView || currentView.type !== "dayGridMonth") {
            return; // Exit view
          }
    
          // Add new ellipse if applicable
          const workHours = date ? datewiseHours[date] : null;
    
          if (!workHours || workHours === "0" || workHours === "00:00" || workHours.trim() === "") return;
    
          const ellipse = document.createElement("div");
          ellipse.className = "hours-ellipse";
          ellipse.innerText = `${workHours}`;
          ellipse.style.cssText = `
            display: flex;
            align-items: center;
            justify-content: center;
            width: 50%;
            height: 20%;
            background-color: white;
            border-radius: 15px;
            font-size: 12px;
            position: absolute;
            bottom: 5px;
            left: 50%;
            transform: translateX(-50%);
            font-weight: 400;
            color: black;
            padding: 5px;
          `;
          cell.style.position = "relative";
          cell.appendChild(ellipse);
        });
      }, 100);
    };
  
  const getCurrentRange = () => {
    const calendarApi = calendarRef.current?.getApi();
    const view = calendarApi?.view;
  
    if (view) {
      const start = new Date(view.currentStart);
      start.setDate(start.getDate() + 1);
  
      const end = new Date(view.currentEnd);
      end.setDate(end.getDate() + 1);
  
      setCurrentView({
        start: start.toISOString(),
        end: end.toISOString(),
        type:view.type
      });
    }
  };

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user") || "{}");
    const loggedInUserId = String(storedUser?.id);
    const role=storedUser?.role_name
    setLoggedInUserId(loggedInUserId)
    setUserRole(role)
  }, []); // run once on mount

  useEffect(() => {
    const employees = filtersData?.employees || [];
    if (employees.length > 0) {
      const formatted: Option[] = employees.map((u: any) => ({
        value: String(u.id),
        label: u.name,
        image_url: u.image_url,
      }));
    
      setUsers(formatted);
      setSelectedUserId(loggedInUserId);  
  
      if (filtersData?.reporting_head_flag !== undefined) {
        setIsReportingHead(filtersData.reporting_head_flag);
      }
    }
  }, [filtersData]);

  const handleReset = () => {
        localStorage.removeItem("attendanceCalendarFilters");
    navigate(`/attendance-view/C`, { replace: false });
    setSelectedUserId(loggedInUserId);  // Reset selected user
  };

 useEffect(() => {
    const isResetVisible =
      selectedUserId && String(selectedUserId) !== String(loggedInUserId);

    const AttendanceFilters = () => (
  <div>
    <div className="holiday-full-width attendance-filters d-flex align-items-center">
      {/* Toggle Icons */}
      <div
        className="d-flex align-items-center border bg-white rounded p-1 icon-list toggle-att-mobile"
        style={{ left: sidebarWidth, position: "absolute" }}
      >
        <Link to="/attendance-view/A" className="btn btn-icon btn-sm me-1">
          <i className="ti ti-list-details" />
        </Link>
        <Link
          to="/attendance-view/C"
          className="btn btn-icon btn-sm active bg-primary text-white"
        >
          <i className="ti ti-calendar-event" />
        </Link>
      </div>

      {/* Filters */}
      {(userRole === 1 || (userRole === 2 && isReportingHead)) && (
        <div className="d-flex align-items-center gap-2">
          {/* Reset Button */}
          {isResetVisible && (
            <button
              className="btn add_btn_size btn-outline-primary att-add-margin-right"
              onClick={handleReset}
              title="Reset"
            >
              <i className="ti ti-refresh" />
            </button>
          )}

          {/* Select Box */}
          <div
            className="holiday-flex"
            style={{
              position:isMobile?"absolute":"static",
              right: isMobile?"10px":"0",
              left: isResetVisible&&isMobile ? "128px" : "88px",
            }}
          >
            <CommonSelect
              className="select"
              options={users}
              value={users.find((u) => u.value === selectedUserId) || null}
              onChange={(selectedOption: any) => {
                handleUserChange(selectedOption?.value || null);
              }}
              forceFullWidth={isMobile}
            />
          </div>
        </div>
      )}
    </div>
  </div>
);

  
    setFilters(<AttendanceFilters />);
    return () => {
      console.log("cleaning up filters");
      setFilters(null);
    };
  }, [
    setFilters,
    users,
    userRole,
    isReportingHead,
    loggedInUserId,
    selectedUserId,
    isMobile 
  ]);
  
  const getModalContainer = () => {
    const modalElement = document.getElementById('modal-datepicker');
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };
  const getModalContainer2 = () => {
    const modalElement = document.getElementById('modal_datepicker');
    return modalElement ? modalElement : document.body; // Fallback to document.body if modalElement is null
  };
  const calendarRef = useRef<FullCalendar>(null);
  
  useEffect(() => {
    if (currentView) {
      fetchAttendance();
    }
  }, [currentView, selectedUserId, selectedDate]);
  

  useEffect(() => {
    setTimeout(() => {
      getCurrentRange();
    }, 0); // Wait till calendar is rendered
  }, []);

  const [date, setDate] = useState<Nullable<Date>>(null);

  // const handleEventClick = (info: any) => {
  //   setEventDetails(info.event.title);
  //   setShowEventDetailsModal(true);
  // };

  // const handleAddEventClose = () => setShowAddEventModal(false);
  // const handleEventDetailsClose = () => setShowEventDetailsModal(false);

  const stats = [
    { title: "Today", value: TodayHours },
    { title: "Total", value: TotalMinute },
    { title: "Break", value: TotalBreakminute },
    ...(userRole === 1 ? [{ title: "Unverified", value: TotalUnverifiedrecord },{ title: "Errors", value: errorCount }] : []),
  ];

  return (
    <>
  <div className="page-wrapper">
    <div className="content">
       <div className="row custom-att-boxes">
          {stats.map((item, index) => (
            <div key={index}>
              <div className="card flex-fill att-card">
                <div className="card-body d-flex align-items-center justify-content-between box-padding boxes-att-mobile">
                  <div className="d-flex align-items-center overflow-hidden">
                    <div>
                      <p 
                        className={`fs-16 mb-1 text-truncate att-boxes-title ${
                          item.title === "Unverified"
                            ? "att-title-ellipsis"
                            : item.title === "Today" || item.title === "Errors"
                            ? "att-today-ellipsis"
                            : ""
                        }`}
                      >
                        {item.title}
                      </p>
                      <h3 className="mb-0 att-boxes-value">{item.value}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

          <div className="row custom-leave-boxes">
            {/* Calendar Sidebar */}
            <div className="col-xxl-9 col-xl-8 theiaStickySidebar calendar-padding">
              <div className="stickybar">
                <div className="card border-0 att-card">
                  <div className="card-body calendar-spacing">
                    <FullCalendar
                      plugins={[
                        dayGridPlugin,
                        timeGridPlugin,
                        interactionPlugin,
                      ]}
                      initialView="dayGridMonth"
                      events={events}
                      headerToolbar={{
                        start: "today,prev,next",
                        center: "title",
                        end: "dayGridMonth,dayGridWeek,dayGridDay",
                      }}
                      // eventClick={handleEventClick}
                      ref={calendarRef}
                      datesSet={handleDatesSet}
                      navLinks={true}
                    />
                  </div>
                </div>
              </div>
            </div>
            {/* /Calendar Sidebar */}
            <div className="col-xxl-3 col-xl-4 theiaStickySidebar">
              <div className="stickybar">
                <div className="card att-card">
                  <div className="card-body p-3 calendar-spacing">
                    {/* Event */}
                    <div className="">
                      <div className="d-flex align-items-center justify-content-between mb-2">
                        <h5 className="font-light">LEGENDS</h5>
                      </div>
                      <div id="external-events">
                        <div
                          className="fc-event bg-paid mb-1 font-light"
                          data-event='{ "title": "Paid" }'
                          data-event-classname="bg-transparent-success"
                        >
                          Paid
                        </div>
                        <div
                          className="fc-event bg-unpaid mb-1 font-light"
                          data-event='{ "title": "Unpaid" }'
                          data-event-classname="bg-transparent-danger"
                        >
                          Unpaid
                        </div>
                        <div
                          className="fc-event bg-holiday mb-1 font-light"
                          data-event='{ "title": "Holiday/Weekoff" }'
                          data-event-classname="bg-transparent-purple"
                        >
                          Holiday/Weekoff
                        </div>
                        <div
                          className="fc-event bg-leave mb-1 font-light"
                          data-event='{ "title": "Leave" }'
                          data-event-classname="bg-transparent-skyblue"
                        >
                          Leave
                        </div>
                        <div
                          className="fc-event bg-today font-light"
                          data-event='{ "title": "Today" }'
                          data-event-classname="bg-transparent-warning"
                        >
                          Today
                        </div>
                      </div>
                    </div>
                    {/* /Event */}
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div>
          <Footer />
        </div>
      </div>
      {/* /Page Wrapper */}

      <>
        {/* Add New Event */}
        <div className="modal fade" id="add_event">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add New Event</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form action="calendar.html">
                <div className="modal-body">
                  <div className="row">
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label">Event Name</label>
                        <input type="text" className="form-control" />
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label">Event Date</label>
                        <div className="input-icon-end position-relative">
                          <DatePicker
                            className="form-control datetimepicker"
                            format={{
                              format: "DD-MM-YYYY",
                              type: "mask",
                            }}
                            getPopupContainer={getModalContainer}
                            placeholder="DD-MM-YYYY"
                          />
                          <span className="input-icon-addon">
                            <i className="ti ti-calendar text-gray-7" />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Start Time</label>
                        <div className="input-icon-end position-relative">
                        <TimePicker getPopupContainer={getModalContainer2} use12Hours placeholder="Choose" format="h:mm A" className="form-control timepicker" />
                          <span className="input-icon-addon">
                            <i className="ti ti-clock text-gray-7" />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">End Time</label>
                        <div className="input-icon-end position-relative">
                        <TimePicker getPopupContainer={getModalContainer2} use12Hours placeholder="Choose" format="h:mm A" className="form-control timepicker" />
                          <span className="input-icon-addon">
                            <i className="ti ti-clock text-gray-7" />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="mb-3">
                        <label className="form-label">Event Location</label>
                        <input type="text" className="form-control" />
                      </div>
                      <div className="mb-0">
                        <label className="form-label">Descriptions</label>
                        <textarea
                          className="form-control"
                          rows={3}
                          defaultValue={""}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Add Event
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Add New Event */}
      </>




<ToastContainer position="top-right" autoClose={3000} />
    </>

  );
};

export default AttendanceCalendar;
